import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Elm } from "../models/elm";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UploadedFile } from "../models/uploaded-file";

@Injectable({
  providedIn: "root",
})
export class ElmService {
  uploadFolder: string;

  constructor(private http: HttpClient) {}

  setS3config(s3config) {
    this.uploadFolder = s3config.uploadFolder;
  }

  getAll(): Observable<Elm[]> {
    return this.http.get<Elm[]>(`${environment.baseUrl}/elm`).pipe(
      map((elms) =>
        elms.map((elm) => ({
          ...elm,
          date: new Date(elm.date),
        }))
      )
    );
  }

  createElm(elm: Elm) {
    return this.http.put<any>(`${environment.baseUrl}/elm`, {
      ...elm,
      date: elm.date.toISOString(),
    });
  }

  addFileKey(elmId: String, fileKey: String) {
    return this.http.post(`${environment.baseUrl}/elm/${elmId}/fileKey`, {
      fileKey,
    });
  }

  async putElmFile(elm: Elm, elmFile: any) {
    const fileName = `ELM-${elm.dep}-${new Date().toISOString()}`;
    const key = `${this.uploadFolder}elms/${fileName}`;
    await this.putToS3Presigned(elmFile, key);
    await this.addFileKey(elm.id, key).toPromise();
  }

  async getElmFile(elm: Elm) {
    return this.getFromS3(elm.fileKey);
  }

  getFromS3(key: string) {
    return this.http.post(
      "`${environment.baseUrl}/campaign/download",
      { key },
      {
        responseType: "blob",
        observe: "response",
      }
    );
  }

  // putToS3(uploadedFile: UploadedFile, key: string) {
  //   // Convert the file data to base64 if needed
  //   const reader = new FileReader();
  //   return new Promise((resolve, reject) => {
  //     reader.onload = () => {
  //       const base64Data = reader.result as string;
  //       const payload = {
  //         key: key,
  //         data: base64Data.split(",")[1], // Remove the data:image/xxx;base64, prefix
  //         contentType: uploadedFile.file.type,
  //       };

  //       this.http
  //         .post(`${environment.baseUrl}/campaign/upload`, payload)
  //         .pipe(
  //           map((response: any) => {
  //             if (response.success) {
  //               return response;
  //             } else {
  //               throw new Error("Upload failed");
  //             }
  //           })
  //         )
  //         .subscribe({
  //           next: (result) => resolve(result),
  //           error: (error) => reject(error),
  //         });
  //     };

  //     reader.onerror = () => {
  //       reject(new Error("Failed to read file"));
  //     };

  //     reader.readAsDataURL(uploadedFile.file);
  //   });
  // }

  readFileAsBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(blob);
    });
  }

  async putToS3Presigned(blob: Blob, key: string): Promise<any> {
    // Step 1: Get presigned URL from backend
    const presignedRes: any = await this.http
      .post(`${environment.baseUrl}/elm/upload`, {
        key,
        contentType: blob.type,
      })
      .toPromise();

    const presignedUrl = presignedRes.url;

    // Step 2: Upload file directly to S3 using fetch
    const uploadResponse = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": blob.type,
      },
      body: blob,
    });

    if (!uploadResponse.ok) {
      const errText = await uploadResponse.text();
      throw new Error(`Upload failed: ${uploadResponse.status} ${errText}`);
    }

    // Step 3: (Optional) Return something useful
    return {
      success: true,
      key,
      location: presignedUrl.split("?")[0], // public path if readable
    };
  }
}
